import React from "react";

export interface CustomRadioOption {
  value: string;
  label: string;
  description?: string;
  bodyContent?: React.ReactNode;
}

interface CustomRadioGroupProps {
  name: string;
  options: CustomRadioOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  direction?: "row" | "col";
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  name,
  options,
  value,
  onChange,
  className = "",
  direction = "col",
}) => (
  <div className={`flex flex-${direction} gap-6 ${className}`}>
    {options.map((option) => (
      <label key={option.value} className="flex gap-3 items-start cursor-pointer select-none">
        <span className="relative flex items-center h-6 w-6 mt-1 flex-shrink-0">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            className="peer appearance-none w-6 h-6 border-2 border-[var(--color-semantic-border-secondary,#DCDDE0)] rounded-full transition-colors checked:border-[var(--color-semantic-bg-brand-bold,#197278)]"
          />
          {/* Outer ring */}
          <span className={`
            pointer-events-none absolute left-0 top-0 w-6 h-6 rounded-full
            border-2
            ${value === option.value
              ? 'border-[var(--color-semantic-bg-brand-bold,#197278)]'
              : 'border-[var(--color-semantic-border-secondary,#DCDDE0)]'
            }
          `}></span>
          {/* Inner dot */}
          {value === option.value && (
            <span className="pointer-events-none absolute left-1/2 top-1/2 w-3.5 h-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[var(--color-semantic-bg-brand-bold,#197278)]"></span>
          )}
        </span>
        <div className="flex flex-col items-start w-full">
          <div className="font-semibold text-body text-semantic-text-primary leading-6">{option.label}</div>
          {option.description && (
            <div className="text-sm text-semantic-text-secondary mt-1">{option.description}</div>
          )}
          {option.bodyContent && value === option.value && (
            <div className="w-full -ml-9 mt-3">
              {option.bodyContent}
            </div>
          )}
        </div>
      </label>
    ))}
  </div>
);

export default CustomRadioGroup; 